// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"_3Q5_G","content":"zFZBs","vertical":"_3Mip6","title":"_1Yxqb"};